import React, {useCallback, useState, useEffect, useRef} from 'react';
import jsonQuery from 'json-query';

import cx from './index.module.scss';

const CompanySelector = ({onSubmit, data}) => {
  const [value, setValue] = useState('');
  const [companies, setCompanies] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  useEffect(() => {
    if (value) {
      const companies = jsonQuery(`companies[*name~/^${value}/i]`, {
        data: { companies: data },
        allowRegexp: true,
      }).value;
      if (companies) setCompanies(companies);
    } else {
      setCompanies([]);
    }
  }, [value, setCompanies, data]);

  const handleChange = useCallback(event => {
    const newValue = (() => {
      const { value } = event.target;
      return value.replace('\\', '');
    })();
    setValue(newValue);
  }, [setValue]);

  const handleClickResult = useCallback(company => {
    setValue(company.name);
    onSubmit(company);
  }, [onSubmit, setValue]);

  const handleSubmit = useCallback(value => {
    const company = companies.find(company => company.name === value);
    onSubmit(company);
  }, [onSubmit, companies]);

  const handleKeyUp = useCallback((event) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      handleSubmit(event.target.value);
    }
  }, [handleSubmit]);

  return (
    <div className={cx.wrap}>
      <div className={cx.search}>
        <div className={cx.inputWrap}>
          <input
            className={cx.searchInput}
            type="text"
            value={value}
            onChange={handleChange}
            onKeyUp={handleKeyUp}
            ref={inputRef}
          />
          <button className={cx.buttonSearch} onClick={event => handleSubmit(event.target.value)}>검색</button>
        </div>
      </div>
      <div className={cx.searchResults}>
        {companies.length > 0 && companies.map((company) => (
          <button
            className={cx.searchResult}
            key={`company-item-${company.name}`}
            onClick={() => handleClickResult(company)}
          >{company.name}</button>
        ))}
      </div>
    </div>
  );
};

export default CompanySelector;
